<template>
    <div class="mb-3" :class="customclass">
        <div class="card-header border" v-if="summaryMobile" id="headingOne">
            <h2 class="mb-0">
                <button class="btnTertiary w-100 justify-content-between" type="button" data-toggle="collapse"
                    data-target="#collapseOne" @click="toggleSummary()">
                    {{ __('messages.summary_reservation') }}
                    <i class="icons-chevron-down"></i>
                </button>
            </h2>
        </div>

        <div :id="getSummaryClass" :class="summaryClass" data-parent="#accordionSummary">
            <div class="card overflow-hidden" 
                :style="{ borderRadius: (getExchange.base !== getExchange.currency && summary.rate.collectType != 2) ? '4px 4px 0 0' : '' }">
                <div class="col-12 card-header border-bottom d-none d-lg-block">
                    <h3 class="m-0">{{ __('messages.summary_reservation') }}</h3>
                </div>
                <div class="card-body p-0">
                    <div class="pl-3 pr-3 pt-2">
                        <div class="col-12 p-0">
                            <i :class="`font-icons icon-${summary.stars}-star font-14`"></i>
                            <h5 class="h5 m-0">{{ summary.name }}</h5>
                            <p class="text-muted small">
                                <small>
                                    {{ summary.location.street }}, {{ summary.location.city }},
                                    {{ summary.location.state }}, {{ summary.location.country }}
                                </small>
                            </p>
                        </div>
                    </div>

                    <div class="summary-details pl-3 pr-3 pt-2">
                        <ul class="list-dots">
                            <li>
                                <span class="font-icons icons-calendar-depart"></span>
                                <strong>{{ __('messages.checkin') }}:</strong> {{ summary.checkIn | date("ddd D MMM YYYY")}}
                                {{ summary.room.checkInTime }}
                            </li>
                            <li>
                                <span class="font-icons icons-calendar-return"></span>
                                <strong>{{ __('messages.checkout') }}:</strong> {{ summary.checkOut | date("ddd D MMM YYYY") }}
                                {{ summary.room.checkOutTime }} ({{ __('messages.midday') }})
                            </li>
                            <li>
                                <span class="font-icons icons-person"></span>
                                <strong>{{ __('messages.guests') }}:</strong> {{ summary.adults }} {{
                                    __('messages.adults') }}
                                <span v-if="summary.children">
                                    {{ __('messages.and') }} {{ summary.children }} {{ __('messages.children') }}
                                </span>
                            </li>
                        </ul>
                    </div>

                    <hr class="border-row my-0" />
                    <SumaryMinify :summary="summary" @discount-changed="handleDiscountChange" :listrooms="listRooms">
                    </SumaryMinify>

                    <Breakdown v-if="summary.rate.collectType !== 2" :summary="summary" :source="source"
                        :isMetaTotal="isMetaTotal" :currencySite="currencySite" />
                </div>
            </div>
            <div class="card price bg-light border-secondary overflow-hidden" 
                :class="{'rounded-0': getExchange.base != getExchange.currency, 'mt-2': getExchange.base == getExchange.currency}" 
                v-if="summary.rate.bookNowPayLater.isBookNowPayLater">
                <div class="card-body bg-white">
                    <div class="row summary-details">

                        <div class="col-12">
                            <p class="h6 radp-title">
                                <i class="icon-aside icon-rapd align-middle"></i> {{ __('messages.rapd_title_summary')
                                }}
                            </p>
                        </div>
                        <div class="col-6 d-flex justify-content-start">
                            <span class="">
                                {{ __('messages.total_reservation') }}
                            </span>
                        </div>
                        <div class="col-6 d-flex justify-content-end">
                            <span class="">
                                <currency-display :amount="summary.totalRate.totalAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                            </span>
                        </div>

                        <div class="col-6 d-flex justify-content-start mt-1">
                            <span class="font-weight-bold h6">
                                {{ __('messages.total_booknow') }}
                            </span>
                        </div>
                        <div class="col-6 d-flex justify-content-end mt-1">
                            <span class="font-weight-bold h6">
                                <currency-display :amount="0" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                            </span>
                        </div>

                        <div class="col-6 d-flex justify-content-start">
                            <span class="">
                                {{ __('messages.date_limit_booknow') }}
                            </span>
                        </div>
                        <div class="col-6 d-flex justify-content-end">
                            <span>
                                {{ summary.rate.bookNowPayLater.dateLimitBookNowPayLater | date(__("formaters.rapd")) |
                                    removedots }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <NotifyCurrency v-if="summary.rate.collectType != 2" :source="source"/>
        </div>
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import ResidentsColo from './ResidentsColo';
import NotifyCurrency from './NotifyCurrency'
import { CookieService } from '../../services/CookieService';
import { useExchangeRateStore } from "../../stores/exchange";

export default {
    props: {
        summary: {
            type: Object,
            required: true
        },
        customclass: {
            type: String,
            default: ""
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        summaryMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            siteConfig: window.__pt.settings.site,
            source: "",
            totalExluded: 0,
            isMetaTotal: window.__pt.settings.site.isMetaTotal,
            currencySite: window.__pt.settings.site.currency,
            listRooms: []
        };
    },
    setup() {
        const exchangeStore = useExchangeRateStore();

        const { getExchange } = storeToRefs(exchangeStore);
        
        return {
            getExchange
        }
    },
    computed: {
        summaryClass() {
            return {
                'collapse show': this.summaryMobile && this.isMobile,
                'collapse': this.summaryMobile && !this.isMobile
            };
        },
        getSummaryClass() {
            return this.summaryMobile ? "collapseOne" : "";
        },

    },
    mounted() {
        this.getCookieSource();
        this.mergeRooms();
    },
    methods: {
        getCookieSource() {
            this.source = CookieService.getCookie("source_origin");
            this.totalExluded = this.summary.rate.breakdownExcluded.reduce((acc, item) => acc + item.amount, 0);
        },
        toggleSummary() {
            this.open = !this.open;
            this.isMobile = false;
        },
        handleDiscountChange(isDiscountApplied) {
            this.$emit('discount-changed', isDiscountApplied);
        },
        mergeRooms() {
            const map = new Map();
            this.summary.ratesWithRooms.forEach((item) => {
                const key = `${item.room.name}${item.room.mealPlan}${item.rate.cancellation.isCancellationFree}`;
                if (map.has(key)) {
                    const existingItem = map.get(key);
                    existingItem.room.quantity += item.room.quantity;
                } else {
                    map.set(key, { ...item, room: { ...item.room, quantity: item.room.quantity } });
                }
            });
            this.listRooms = Array.from(map.values());
        }

    },
    components: {
        ResidentsColo,
        NotifyCurrency
    }
};
</script>
